import React from 'react';
import {Info} from 'lucide-react';

const PlansNotFound: React.FC = () => {
    return (
      <div className="p-4 my-4 text-orange-800 border border-orange-300 rounded-lg bg-orange-50" role="alert">
        <div className="flex items-center">
          <Info className="flex-shrink-0 w-4 h-4 me-2" />
          <h3 className="text-lg font-medium">Oh snap!!!</h3>
        </div>
        <div className="my-2 text-sm">
          Sorry, unfortunately we couldn't find any broadband plans for your address. If you need email further help, please contact our team at support@frednet.co.nz.
        </div>
      </div>
    );
  };

export default PlansNotFound;
